import { authFetch } from './http/fetchClient';
import { FocusBaseUrl } from 'Utils/Utils';

// `signal` lets the caller cancel a listing it no longer needs (e.g. the user
// opened another folder or closed the picker).
export const focusModeApi = {
  getAllItems: async (signal?: AbortSignal): Promise<any> => {
    const res = await authFetch(`${FocusBaseUrl()}/focus_mode/user_accessible_items/`, { signal });
    if (!res.ok) throw new Error(`Focus mode request failed: ${res.status}`);
    return res.json();
  },

  getBoxFolderItems: async (folderId: string, signal?: AbortSignal): Promise<any> => {
    const res = await authFetch(
      `${FocusBaseUrl()}/focus_mode/user_accessible_items/?folder_id=${encodeURIComponent(folderId)}`,
      { signal }
    );
    if (!res.ok) throw new Error(`Focus mode request failed: ${res.status}`);
    return res.json();
  },
};
